import React from "react";
import propTypes from "prop-types";
import classnames from "classnames";

import "./ButtonBar.scss";
import { createDataAttributes } from "../../utilities";

const ButtonBar = ({
  children,
  fullWidth,
  column,
  size,
  className,
  dataAttrib,
  ...rest
}) => {
  const containerClasses = classnames("uikit__button-bar", className, {
    "uikit__button-bar__full-width": fullWidth && !column,
    "uikit__button-bar__columned": column
  });

  const validButtonTypes = ["button", "submit", "reset"];
  return (
    <div
      {...rest}
      className={containerClasses}
      {...createDataAttributes(dataAttrib)}
    >
      {React.Children.map(children, child => {
        // we double-check to make sure only to retrun buttons in case someone
        // includes a non-button item inside the button bar
        return validButtonTypes.includes(child?.props?.type) ? (
          <child.type {...child.props} size={size} />
        ) : null;
      })}
    </div>
  );
};

ButtonBar.propTypes = {
  fullWidth: propTypes.bool,
  column: propTypes.bool,
  className: propTypes.string,
  children: propTypes.oneOfType([
    propTypes.arrayOf(propTypes.node),
    propTypes.node
  ]).isRequired,
  // size is passed down to the Button
  size: propTypes.oneOf(["sm", "md", "lg"]),
  dataAttrib: propTypes.arrayOf(Object)
};

ButtonBar.defaultProps = {
  fullWidth: false,
  column: false,
  size: "md"
};

export default ButtonBar;
